<template>
  <button @click="$emit('click')"
          class="form__btn">
    <slot></slot>
  </button>

</template>

<script>

export default {
  name: 'CButton',

  inheritAttrs: false,
  components: {},
  props: {

  },
  data() {
    return {

    }
  },
  watch: {

  },
  computed: {},
  mounted() {

  },
  methods: {},


}
</script>
